import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

export const hasHistory = () => (window.history.state?.idx ?? 0) > 0;

export const useBack = () => {
  const nav = useNavigate();
  const { user } = useAuth();
  const fallback = user ? "/dashboard" : "/";
  const back = useCallback(() => (hasHistory() ? nav(-1) : nav(fallback, { replace: true })), [nav, fallback]);
  return { back, fallback };
};

export const BackButton = ({ className = "", testid = "back-btn" }) => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const { back, fallback } = useBack();
  if (!hasHistory() && pathname === fallback) return null;
  return (
    <button type="button" onClick={back} data-testid={testid} title={t("nav.back")} aria-label={t("nav.back")}
      className={`cx-metal group inline-flex items-center gap-2 rounded-full pl-2.5 pr-4 py-1.5 text-xs font-medium ${className}`}>
      <ArrowLeft className="w-4 h-4 transition-transform duration-200 group-hover:-translate-x-0.5" />
      <span>{t("nav.back")}</span>
    </button>
  );
};
